import styled from 'styled-components';
import { Table } from 'antd';

export default styled(Table)`
  .perfect-table-fit & {
    margin-left: -16px;
    margin-right: -16px;
    margin-bottom: -16px;
  }
  .ant-table-thead > tr > th {
    font-weight: bold;
    font-family: 'Maison Neue';
  }
  .ant-table-tbody > tr > td {
    font-family: 'Maison Neue';
  }
  .selected-invite {
    border: 2px solid #448ef7;
    td {
      background: #deecff;
      border-top: 2px solid #448ef7;
      border-bottom: 2px solid #448ef7;
    }
  }
`;
